"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
exports.ColumnMenuItem = function (props) {
    return (React.createElement("div", { onClick: props.onClick, className: "k-columnmenu-item" + (props.selected ? ' k-state-selected' : '') },
        props.iconClass && React.createElement("span", { className: "k-icon" + (props.iconClass ? ' ' + props.iconClass : '') }),
        props.title));
};
//# sourceMappingURL=ColumnMenuItem.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/columnmenu/ColumnMenuItem.js
// module id = 295
// module chunks = 0